<div class="card" (click)="onCardClick($event)">
  <div class="card-header">
    @if (images && images.length > 0) {
      <p-galleria
        [value]="images"
        [showThumbnails]="false"
        [showIndicators]="false"
        [circular]="false"
        [autoPlay]="false"
        [transitionInterval]="4000"
        [activeIndex]="currentImageIndex"
      >
        <ng-template pTemplate="item" let-item>
          <img
            [src]="item.source"
            [alt]="item.alt"
            style="height: 191px; width: 100%"
          />
        </ng-template>
        <ng-template pTemplate="caption" let-item>
          <div class="p-pt-2">
            <div class="caption-header">
              <span i18n="@@imageCounter">{{ currentImageIndex + 1 }} of {{ images.length }}</span>
            </div>
            <div class="caption-title-navigation">
              <p class="caption-title">{{ item.title }}</p>
              <div class="navigation">
                <button
                  pButton
                  (click)="previousImage()"
                  [disabled]="currentImageIndex === 0"
                >
                  <i class="ri-arrow-left-s-line"></i>
                </button>
                <button
                  pButton
                  (click)="nextImage()"
                  [disabled]="currentImageIndex === images.length - 1"
                >
                  <i class="ri-arrow-right-s-line"></i>
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </p-galleria>
    } @else {
      <div class="no-image-placeholder">
        <img height="100" src="assets/images/logo.png">
      </div>
    }
  </div>

  <div class="card-content">
    <div class="status" [ngClass]="heroReport.status.toLowerCase()">
      {{ heroReport.status }}
    </div>
    @if (classificationLabels.length > 0) {
      <div>
        <h3 class="classification-labels">
          {{ classificationLabels.join(", ") }}
        </h3>
      </div>
    }
    @if (showsMgrs) {
      <p><span i18n="@@sre.card.mgrs">MGRS</span>: <span dir="ltr">{{ heroReport.mgrs }}</span></p>
    } @else {
      <p>{{ coordinates }}</p>
    }

    <p i18n="@@reportMetaInfo">
      Reported by {{ heroReport.pocName || "Unknown" }} on
      {{
        heroReport.createdDate
          ? (heroReport.createdDate | date : "MM/dd/yyyy hh:mm a")
          : "Unknown"
      }}
    </p>
  </div>

  <div class="card-footer">

    <button
      [routerLink]="[
        '/hero-report',
        heroReport.id,
        'incident',
        heroReport.eodIncidentReport.id
      ]"
      *ngIf="canViewEod && heroReport.eodIncidentReport?.id"
      pButton
      type="button"
      label="View EOD Report"
      i18n-label="@@viewEodReport"
      class="p-button-primary">
    </button>

    <button
      [routerLink]="['/hero-report', heroReport.id]"
      pButton
      type="button"
      label="View Hero Report"
      i18n-label="@@viewHeroReport"
      class="p-button-primary">
    </button>

    <button
      [routerLink]="['/hero-report', heroReport.id, 'incident']"
      *ngIf="canViewEod && !heroReport.eodIncidentReport?.id && heroReport.reportType !== 'SRE'"
      pButton
      type="button"
      label="Create EOD Report"
      i18n-label="@@createEodReport"
      class="p-button-outlined">
    </button>

  </div>
</div>